import React from "react";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import FridgeService from "./service/FridgeService";
import i18n from "../../i18n";

class UpdateFoodInFridgeComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      foodCategory: "",
      image: "",
      measure: this.props.userFood.measure,
      quantity: this.props.userFood.quantity,
      weight: "",
      data: [],
      isDataLoading: false,
      show: false,
      error: "",
    };
    this.click = this.click.bind(this);
    this.fieldChange = this.fieldChange.bind(this);
  }

  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });

  fieldChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  click() {
    this.setState({ isDataLoading: true });
    FridgeService.updateFood(this.props.userFood.id, this.state)
      .then((response) => {
        this.setState({ data: response.data, isDataLoading: false });
        window.location.reload(true);
      })
      .catch((err) => {
        this.setState({ data: err, isDataLoading: false });
        this.setState({
          error: "Unavaible to update at this time",
        });
      });
  }

  render() {
    return (
      <span>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              <p style={{ color: "red" }}>
                <b>
                  <u>{this.state.error && this.state.error}</u>
                </b>
              </p>
              <p>{i18n.t("fridgeTable_edit_title")}</p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput2"
              >
                <Form.Label>{i18n.t("fridgeTable_edit_quantity")}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="123"
                  name="quantity"
                  required
                  value={this.state.quantity}
                  onChange={this.fieldChange}
                />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput3"
              >
                <Form.Label>{i18n.t("fridgeTable_edit_measurment")}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="cups, kg, mg, tbs..."
                  name="measure"
                  required
                  value={this.state.measure}
                  onChange={this.fieldChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              {i18n.t("fridgeTable_edit_close")}
            </Button>
            <Button variant="primary" onClick={(this.handleClose, this.click)}>
              {i18n.t("fridgeTable_button_edit")}
            </Button>
          </Modal.Footer>
        </Modal>

        <Button
          variant="outline-success"
          onClick={this.handleShow}
          disabled={this.state.isDataLoading}
        >
          {i18n.t("fridgeTable_button_edit")}
        </Button>
      </span>
    );
  }
}
export default UpdateFoodInFridgeComponent;
